module.exports = __webpack_public_path__ + "img/round3x.e2338c11.png";